export default "__VITE_ASSET__496ae972__"